import axios from "axios";
import * as Sentry from "@sentry/browser";
import { GRAPHQL_API } from "../graphql/endpoint";
import { renewAccessTokenMutation } from "../graphql/queries/authentication";
import { CustomLocalStorage, TOKEN_KEYS } from "../../utils/customStorage";

let inFlightRefresh = null;

export const refreshAccessToken = async () => {
  if (inFlightRefresh) return inFlightRefresh;
  inFlightRefresh = (async () => {
  const refreshToken = await CustomLocalStorage.getItem(TOKEN_KEYS.REFRESH);
  if (!refreshToken) return null;
  try {
    const response = await axios.post(GRAPHQL_API, {
      query: renewAccessTokenMutation(refreshToken),
    });
    if (!response.data?.errors && response.data?.data?.refreshToken) {
      const { token: newAccessToken, refreshToken: newRefreshToken } = response.data.data.refreshToken;
      await CustomLocalStorage.setItem(TOKEN_KEYS.ACCESS, newAccessToken);
      await CustomLocalStorage.setItem(TOKEN_KEYS.REFRESH, newRefreshToken);
      return newAccessToken;
    }
    // Capture unexpected response shape or GraphQL errors
    const hasGraphQLErrors = Array.isArray(response?.data?.errors) && response.data.errors.length > 0;
    if (hasGraphQLErrors) {
      Sentry.captureMessage("Token refresh failed: GraphQL errors", {
        level: "warning",
        extra: {
          status: response?.status,
          errors: response.data.errors,
        },
        tags: { area: "auth", action: "refreshToken" },
      });
    } else {
      Sentry.captureMessage("Token refresh failed: missing refreshToken in response", {
        level: "warning",
        extra: {
          status: response?.status,
          responseHasData: Boolean(response?.data),
          responseKeys: Object.keys(response?.data || {}),
        },
        tags: { area: "auth", action: "refreshToken" },
      });
    }
  } catch (e) {
    Sentry.captureException(e, { tags: { area: "auth", action: "refreshToken" } });
  }
  return null;
  })();

  try {
    return await inFlightRefresh;
  } finally {
    inFlightRefresh = null;
  }
};


